import React from 'react';
import ImageWrapper from '../common/ImageWrapper';
import PlayStoreButton from '../common/PlayStoreButton';
import AppleStoreButton from '../common/AppleStoreButton';
import AniLink from 'gatsby-plugin-transition-link/AniLink';

const Footer = () => {
    const d = new Date();
    let year = d.getFullYear();
    return (
        <>
            <footer id="desktop_footer">
                <div className="footer_first_div">
                    <AniLink fade to="/">
                        <ImageWrapper
                            ImgUrl={
                                'https://s3.us-east-2.wasabisys.com/ufaber-lms/files/ca7a73c17fbed4d81e139537e743a2fe.svg'
                            }
                            MaxWidth={250}
                        />
                    </AniLink>
                    <p>A product of uFaber Edutech Pvt Ltd.</p>
                </div>
                <div className="footer_second_div">
                    <div className="footer_second_div_contact_details">
                        <div className="footer_contact_details_wrapper">
                            <ImageWrapper
                                ImgUrl={
                                    'http://s3.us-east-2.wasabisys.com/ufaber-lms/files/f30de53a418ee9bff652b9d0de474aea.1691694169997117'
                                }
                                MaxWidth={24}
                            />
                            <p>contact@ufaber.com</p>
                        </div>
                        <div className="footer_contact_details_wrapper">
                            <ImageWrapper
                                ImgUrl={
                                    'http://s3.us-east-2.wasabisys.com/ufaber-lms/files/fcdc2128a0690091c6af68f1ab1b88aa.1691694753736117'
                                }
                                MaxWidth={24}
                            />
                            <p>+91 93219 43330</p>
                        </div>
                        <div className="footer_contact_details_wrapper">
                            <ImageWrapper
                                ImgUrl={
                                    'https://s3.us-east-2.wasabisys.com/ufaber-lms/files/a8f68e2d122563b29c52f28dce21355b.svg'
                                }
                                MaxWidth={24}
                            />
                            <p>
                                Ufaber Edutech Pvt Ltd, 91Springboard, Godrej & Boyce, Gate No. 2, Plant No. 6, LBS Marg, Opposite Vikhroli Bus Depot, Vikhroli West, Mumbai, Maharashtra 400079
                            </p>
                        </div>
                    </div>
                    <div className="footer_second_div_navigation_details">
                        <div
                            className="footer_navigation_details_wrapper"
                            id="navigation_wrapper_first"
                        >
                            <div className="footer_navigation_wrapper">
                                <h6>Programs</h6>
                                <ul>
                                    <AniLink fade to="/programs">
                                        <li>IELTS General</li>
                                    </AniLink>
                                    <AniLink fade to="/programs">
                                        <li>IELTS Academic</li>
                                    </AniLink>
                                    <AniLink fade to="/programs">
                                        <li>PTE</li>
                                    </AniLink>
                                    <AniLink fade to="/programs">
                                        <li>OET</li>
                                    </AniLink>
                                    <AniLink fade to="/programs">
                                        <li>TOEFL</li>
                                    </AniLink>
                                    <AniLink fade to="/programs">
                                        <li>GRE</li>
                                    </AniLink>
                                </ul>
                            </div>
                            <div className="footer_navigation_wrapper">
                                <h6>Pathways</h6>
                                <ul>
                                    <AniLink
                                        fade
                                        to="https://abroadninja.in/study-abroad/"
                                    >
                                        <li>Study Abroad</li>
                                    </AniLink>
                                    <AniLink
                                        fade
                                        to="https://abroadninja.in/settle-abroad/"
                                    >
                                        <li>Permanent Residency</li>
                                    </AniLink>
                                </ul>
                            </div>
                        </div>
                        <div
                            className="footer_navigation_details_wrapper"
                            id="navigation_wrapper_second"
                        >
                            <div className="footer_navigation_wrapper">
                                <h6>Resources</h6>

                                <ul>
                                    <AniLink fade to="/band-predictor">
                                        <li>IELTS Band Predictor</li>
                                    </AniLink>

                                    <AniLink fade to="/oet-score-predictor">
                                        <li> OET Score Predictor</li>
                                    </AniLink>
                                    <AniLink fade to="/pte-score-predictor">
                                        <li> PTE Score Predictor</li>
                                    </AniLink>
                                    <AniLink fade to="/ielts-mock-test">
                                        <li>IELTS Mock Test</li>
                                    </AniLink>

                                    <AniLink fade to="/oet-mock-test">
                                        <li> OET Mock Test</li>
                                    </AniLink>

                                    <AniLink fade to="/pte-mock-test">
                                        <li> PTE Mock Test</li>
                                    </AniLink>

                                    <a href="https://app.ieltsninja.com/masterclasses/">
                                        <li>Masterclasses</li>
                                    </a>
                                    <a href="https://ieltsninja.com/content/">
                                        <li>Exam Tips</li>
                                    </a>
                                    <AniLink fade to="/ielts-mentors">
                                        <li>Mentors</li>
                                    </AniLink>
                                    <AniLink fade to="/videos">
                                        <li>Video Resources</li>
                                    </AniLink>
                                </ul>
                                {/*                                     
                                <ul>
                                    <AniLink fade to="/oet-score-predictor">
                                        <li> OET Score Predictor</li>
                                    </AniLink>
                                    <AniLink fade to="/band-predictor">
                                        <li>Band Predictor Test</li>
                                    </AniLink>
                                    <AniLink fade to="/ielts-mock-test">
                                        <li>Mock Test</li>
                                    </AniLink>
                                    <AniLink
                                        fade
                                        to="https://app.ieltsninja.com/masterclasses/"
                                    >
                                        <li>Masterclasses</li>
                                    </AniLink>

                                    <AniLink fade to="/ielts-mentors">
                                        <li>Mentors</li>
                                    </AniLink>

                                    <AniLink
                                        fade
                                        to="https://ieltsninja.com/content/"
                                    >
                                        <li>Blog</li>
                                    </AniLink>
                                    <AniLink fade to="/videos">
                                        <li>Sample Videos</li>
                                    </AniLink>
                                </ul> */}
                            </div>
                            <div className="footer_navigation_wrapper">
                                <h6>Results</h6>
                                <ul>
                                    <AniLink fade to="/results">
                                        <li>Score Cards</li>
                                    </AniLink>
                                    <AniLink fade to="/success-stories">
                                        <li>Success Stories</li>
                                    </AniLink>
                                </ul>
                            </div>
                        </div>
                        <div
                            className="footer_navigation_details_wrapper"
                            id="navigation_wrapper_third"
                        >
                            <div className="footer_navigation_wrapper">
                                <h6>Quick Links</h6>
                                <ul>
                                    <AniLink fade to="/faqs">
                                        <li>FAQ</li>
                                    </AniLink>
                                    <AniLink fade to="/about-us">
                                        <li>About Us</li>
                                    </AniLink>
                                    <AniLink fade to="/grievance-redressal">
                                        <li>Grievance Redressal</li>
                                    </AniLink>
                                    <AniLink
                                        fade
                                        to="/end-user-license-agreement"
                                    >
                                        <li>User License Agreement</li>
                                    </AniLink>
                                    <AniLink fade to="/privacy-policy">
                                        <li>Privacy Policy</li>
                                    </AniLink>
                                    <AniLink fade to="/terms-of-use">
                                        <li>Terms of Use</li>
                                    </AniLink>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="footer_second_div_social_media_details">
                        <div className="footer_social_media_wrapper">
                            <a
                                target="_blank"
                                href="https://www.instagram.com/ielts.ninja/ "
                            >
                                <ImageWrapper
                                    ImgUrl={
                                        'https://s3.us-east-2.wasabisys.com/ufaber-lms/files/568cc754a9d5a9d3dbbd9b8214d9c5a4.svg'
                                    }
                                    MaxWidth={37.94}
                                />
                            </a>
                            <a
                                target="_blank"
                                href="https://www.facebook.com/ieltsninjadotcom/"
                            >
                                <ImageWrapper
                                    ImgUrl={
                                        'http://s3.us-east-2.wasabisys.com/ufaber-lms/files/b0eb9497ffa5e6f06e05d72821c3df2c.1691703313866117'
                                    }
                                    MaxWidth={37.94}
                                />
                            </a>
                        </div>
                        <p>Get the app</p>
                        <div className="footer_app_store_buttons_wrapper">
                            <PlayStoreButton />
                            <AppleStoreButton />
                        </div>
                    </div>
                </div>
                <div className="footer_third_div">
                    <hr />
                    <p>{year} © uFaber, All rights reserved uFaber Edutech </p>
                </div>
            </footer>
            <footer id="mobile_footer">
                <div className="footer_mobile_first_div">
                    <div className="footer_mobile_first_navigation_details">
                        <div className="footer_mobile_navigation_wrapper">
                            <h6>Programs</h6>
                            <ul>
                                <AniLink fade to="/programs">
                                    <li>IELTS General</li>
                                </AniLink>
                                <AniLink fade to="/programs">
                                    <li>IELTS Academic</li>
                                </AniLink>
                                <AniLink fade to="/programs">
                                    <li>PTE</li>
                                </AniLink>
                                <AniLink fade to="/programs">
                                    <li>OET</li>
                                </AniLink>
                                <AniLink fade to="/programs">
                                    <li>TOEFL</li>
                                </AniLink>
                                <AniLink fade to="/programs">
                                    <li>GRE</li>
                                </AniLink>
                            </ul>
                        </div>
                        <div className="footer_mobile_navigation_wrapper">
                            <h6>Pathways</h6>
                            <ul>
                                <AniLink
                                    fade
                                    to="https://abroadninja.in/study-abroad/"
                                >
                                    <li>Study Abroad</li>
                                </AniLink>
                                <AniLink
                                    fade
                                    to="https://abroadninja.in/settle-abroad/"
                                >
                                    <li>Permanent Residency</li>
                                </AniLink>
                            </ul>
                        </div>
                        <div className="footer_mobile_navigation_wrapper">
                            <h6>Resources</h6>
                            <ul>
                                <AniLink fade to="/band-predictor">
                                    <li>Band Predictor Test</li>
                                </AniLink>
                                <AniLink fade to="/ielts-mock-test">
                                    <li>Mock Test</li>
                                </AniLink>
                                <AniLink
                                    fade
                                    to="https://app.ieltsninja.com/masterclasses/"
                                >
                                    <li>Masterclasses</li>
                                </AniLink>
                                <AniLink
                                    fade
                                    to="https://ieltsninja.com/content/"
                                >
                                    <li>Blog</li>
                                </AniLink>
                                <AniLink fade to="/videos">
                                    <li>Sample Videos</li>
                                </AniLink>
                            </ul>
                        </div>
                    </div>
                    <div className="footer_mobile_second_navigation_details">
                        <div className="footer_mobile_navigation_wrapper">
                            <h6>Results</h6>
                            <ul>
                                <AniLink fade to="/results">
                                    <li>Score Cards</li>
                                </AniLink>
                                <AniLink fade to="/success-stories">
                                    <li>Success Stories</li>
                                </AniLink>
                            </ul>
                        </div>
                        <div className="footer_mobile_navigation_wrapper">
                            <h6>Quick Links</h6>
                            <ul>
                                <AniLink fade to="/faqs">
                                    <li>FAQ</li>
                                </AniLink>
                                <AniLink fade to="/about-us">
                                    <li>About Us</li>
                                </AniLink>
                                <AniLink fade to="/grievance-redressal">
                                    <li>Grievance Redressal</li>
                                </AniLink>
                                <AniLink fade to="/end-user-license-agreement">
                                    <li>User License Agreement</li>
                                </AniLink>
                                <AniLink fade to="/privacy-policy">
                                    <li>Privacy Policy</li>
                                </AniLink>
                                <AniLink fade to="/terms-of-use">
                                    <li>Terms of Use</li>
                                </AniLink>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="footer_mobile_second_div">
                    <AniLink fade to="/">
                        <ImageWrapper
                            ImgUrl={
                                'https://s3.us-east-2.wasabisys.com/ufaber-lms/files/ca7a73c17fbed4d81e139537e743a2fe.svg'
                            }
                            MaxWidth={250}
                        />
                    </AniLink>
                    <p>A product of uFaber Edutech Pvt Ltd.</p>
                </div>
                <div className="footer_mobile_third_div">
                    <div className="footer_mobile_contact_details">
                        <div className="footer_mobile_contact_details_wrapper">
                            <ImageWrapper
                                ImgUrl={
                                    'https://s3.us-east-2.wasabisys.com/ufaber-lms/files/0e87d393f954ff7bfe9e3fdedd9cd9a2.svg'
                                }
                                Width={15}
                            />
                            <p>contact@ufaber.com</p>
                        </div>
                        <div className="footer_mobile_contact_details_wrapper">
                            <ImageWrapper
                                ImgUrl={
                                    'https://s3.us-east-2.wasabisys.com/ufaber-lms/files/5580c43bf239a0773a219655ddf0d44d.svg'
                                }
                                Width={15}
                            />
                            <p>+91 93219 43330</p>
                        </div>
                        <div className="footer_mobile_contact_details_wrapper">
                            <ImageWrapper
                                ImgUrl={
                                    'https://s3.us-east-2.wasabisys.com/ufaber-lms/files/c9e7e9ef53f910b676c2da92a46ff4c9.svg'
                                }
                                Width={32}
                            />
                            <p>
                               Ufaber Edutech Pvt Ltd, 91Springboard, Godrej & Boyce, Gate No. 2, Plant No. 6, LBS Marg, Opposite Vikhroli Bus Depot, Vikhroli West, Mumbai, Maharashtra 400079
                            </p>
                        </div>
                    </div>
                    <div className="footer_mobile_social_media_details">
                        <div className="footer_mobile_social_media_wrapper">
                            <a
                                target="_blank"
                                href="https://www.instagram.com/ielts.ninja/ "
                            >
                                <ImageWrapper
                                    ImgUrl={
                                        'https://s3.us-east-2.wasabisys.com/ufaber-lms/files/568cc754a9d5a9d3dbbd9b8214d9c5a4.svg'
                                    }
                                    MaxWidth={37.94}
                                />
                            </a>
                            <a
                                target="_blank"
                                href="https://www.facebook.com/ieltsninjadotcom/"
                            >
                                <ImageWrapper
                                    ImgUrl={
                                        'http://s3.us-east-2.wasabisys.com/ufaber-lms/files/b0eb9497ffa5e6f06e05d72821c3df2c.1691703313866117'
                                    }
                                    MaxWidth={37.94}
                                />
                            </a>
                        </div>
                        <p>Get the app</p>
                        <div className="footer_mobile_app_store_buttons_wrapper">
                            <PlayStoreButton MaxWidth={133} />
                            <AppleStoreButton MaxWidth={133} />
                        </div>
                    </div>
                </div>
                <div className="footer_mobile_fourth_div">
                    <hr />
                    <p>{year} © uFaber, All rights reserved uFaber Edutech </p>
                </div>
            </footer>
        </>
    );
};

export default Footer;
